﻿class InfoNumber {
    constructor(elm) {
        this.$elm = $(elm);

        this.scopeClass = 'infoNumber';
        this.isOpenModifier = `${this.scopeClass}--isOpen`;
        this.hasItemsModifier = `${this.scopeClass}--hasSubItems`;

        if (this.$elm.hasClass(this.hasItemsModifier)) {
            this.setEventListeners();
        }
    }

    setEventListeners() {
        this.$elm.find('.infoNumber-header').on('click', this.onHeaderClick.bind(this));
    }

    open() {
        this.$elm.addClass(this.isOpenModifier);
    }

    close() {
        this.$elm.removeClass(this.isOpenModifier);
    }

    onHeaderClick(event) {
        event.preventDefault();
        var $target = $(event.target);

        if ($target.closest('.infoNumber-title').length > 0 ||
            $target.closest('.infoNumber-number').length > 0) {

            if (typeof $target.parent().attr('href') !== "undefined")
            {
                var href = $target.closest('a').attr('href');
                window.location.href = href;
            }

        } else {
            if (this.$elm.hasClass(this.isOpenModifier)) {
                this.close();
            } else {
                this.open();
            }
        }
    }
}

export default InfoNumber;